import React from "react";
import { Box } from "@mui/material";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import TextInputField from "./TextInputField";
import CustomAutoComplete from "./CustomAutoComplete";
import NumberAndRangeElement from "../seviceBuilder/NumberAndRangeElement";

interface AttributeRendererProps {
  attribute: any;
  onAttributeChange: (updatedAttribute: any) => void;
}

/**
 * Reusable component for rendering service attributes
 * Used in both ServiceBuilder and LogicBuilder
 */
const AttributeRenderer: React.FC<AttributeRendererProps> = ({
  attribute,
  onAttributeChange,
}) => {
  const theme: Theme = useTheme();

  return (
    <Box key={attribute.id || attribute.attributeID}>
      {/* Text input (type 2) */}
      {attribute.type === 2 && (
        <>
          <Box style={styles.title(theme)}>{attribute.name}</Box>
          <TextInputField
            placeholder={attribute.text}
            value={attribute.textValue || ""}
            handleChange={(e) =>
              onAttributeChange({
                ...attribute,
                textValue: e.target.value,
              })
            }
            name="placeholderInput"
            maxLength={100}
            showCharacterCount={true}
          />
        </>
      )}

      {/* List selection (type 6) */}
      {attribute.type === 6 && (
        <>
          <Box style={styles.title(theme)}>{attribute.name}</Box>
          <CustomAutoComplete
            options={attribute.list || []}
            value={attribute.textValue || ""}
            onChange={(value: string | null) => {
              onAttributeChange({
                ...attribute,
                textValue: value,
              });
            }}
          />
        </>
      )}

      {/* Numeric/Range input (types 1 and 3) */}
      {(attribute.type === 1 || attribute.type === 3) && (
        <NumberAndRangeElement
          attribute={attribute}
          onAttributeChange={(updatedAttribute: any) => {
            onAttributeChange(updatedAttribute);
          }}
        />
      )}

      {/* Unsupported types */}
      {(attribute.type === 4 ||
        attribute.type === 5 ||
        attribute.type === 7) && (
        <>
          <Box style={styles.title(theme)}>{attribute.name}</Box>
          <div>This attribute type should be changed</div>
        </>
      )}
    </Box>
  );
};

export default AttributeRenderer;

const styles = {
  title: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    lineHeight: "20px",
    flex: 1,
    marginBottom: "8px",
  }),
};
